import React, {Component} from "react";
import {NavLink} from "react-router-dom";

class Header extends Component
{
	render()
	{
		document.title = "DateNight: 404";

		return (
			<header className="App-header">
				<h1 className="App-title">DateNight Admin Panel</h1>
				<nav>
					<ul>
						{/* <li>
							<NavLink exact={true} activeClassName="selected" to="/">Dashboard</NavLink>
						</li> */}
						<li>
							<NavLink activeClassName="selected" to="/venues/">Venues</NavLink>
						</li>
						{/* <li>
							<NavLink activeClassName="selected" to="/audit/">Audit</NavLink>
						</li> */}
					</ul>
				</nav>
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js